import React, { forwardRef, type MouseEvent, type ReactNode } from 'react';

import DefaultButton from '@atlaskit/button';
import ChevronDownIcon from '@atlaskit/icon/utility/migration/chevron-down';

import { PaginatedPickerIntlProvider } from '../../../common/utils';

import { ClearButton } from './clear-button';
import { LoadingStateAnimationWrapper } from './loading-state';
import { ButtonWrapper, ChildrenWrapper, StyledChevron, StyledClose } from './styled';

type PickerTriggerProps = {
	isInvalid: boolean;
	isSelected: boolean;
	isLoading?: boolean;
	hasValues: boolean;
	children: ReactNode;
	testId?: string;
	onClick: () => void;
	onClear?: () => void;
};

const PickerTrigger = forwardRef<HTMLElement, PickerTriggerProps>(
	(
		{
			children,
			isInvalid,
			isSelected,
			isLoading,
			hasValues,
			onClick,
			onClear,
			testId,
		}: PickerTriggerProps,
		ref,
	) => {
		if (isLoading) {
			return (
				<PaginatedPickerIntlProvider>
					<LoadingStateAnimationWrapper>
						<DefaultButton isSelected testId={testId}>
							{children}:
						</DefaultButton>
					</LoadingStateAnimationWrapper>
				</PaginatedPickerIntlProvider>
			);
		}
		// TODO : fix spacing.. this is overlapping with the Chevron
		const iconAfter = (
			<ClearButton
				onClick={(e: MouseEvent) => {
					e.stopPropagation();
					onClear?.();
				}}
				label="Remove criteria"
			/>
		);
		const Content = (
			<>
				<ChildrenWrapper>{children}</ChildrenWrapper>
				{onClear ? (
					<StyledClose>{iconAfter}</StyledClose>
				) : (
					<StyledChevron>
						<ChevronDownIcon color="currentColor" label="" LEGACY_margin="-5px 0 0 0" />
					</StyledChevron>
				)}
			</>
		);
		return (
			<PaginatedPickerIntlProvider>
				<ButtonWrapper>
					<DefaultButton
						appearance={isInvalid ? 'danger' : 'default'}
						isSelected={isSelected || hasValues}
						onClick={onClick}
						ref={ref}
						testId={testId}
						aria-expanded={isSelected}
					>
						{Content}
					</DefaultButton>
				</ButtonWrapper>
			</PaginatedPickerIntlProvider>
		);
	},
);

export default PickerTrigger;
